'use strict';

module.exports = require('./Radio');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-radio/lib/index.js
 ** module id = 349
 ** module chunks = 0
 **/